<template>
  <div class="icu-modal-container">
    <close-icon v-if="showClose" @click="$emit('close')" />
    <div v-if="title" class="icu-modal-container__title">
      {{ title }}
    </div>
    <slot name="default"></slot>
  </div>
</template>

<script>
import CloseIcon from '@/components/modals/CloseIcon.vue'
export default {
  name: 'ModalContainer',
  components: { CloseIcon },
  props: {
    showClose: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/modals/ModalContainer.scss";
</style>
